import { ClassNameProps } from "../../models/Props"
import { classNames, classNamesOrEmpty } from "../../style/common"

export type SpinnerProps = {
    classNames?: {
        container?: string | undefined
    }
}

export const Spinner = (props: SpinnerProps) => {
    return (
        <div className={`text-contrast-primary flex flex-col justify-center align-middle items-center ${classNamesOrEmpty(props.classNames?.container)}`}>
            <SpinnerAnimation />
            <span className="mt-4">Loading...</span>
        </div>
    )
}

export const SpinnerAnimation = (props: ClassNameProps) => {
    return (
        <div
            className={classNames("inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]", props.className)}
            role="status">
        </div>
    )
}